import React from "react";
// material-ui components
import withStyles from "material-ui/styles/withStyles";
import Slide from "material-ui/transitions/Slide";
import IconButton from "material-ui/IconButton";
import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";
// @material-ui/icons
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.jsx";
import ModalButton from "components/CustomButtons/ModalButton.jsx";
import javascriptStyles from "assets/jss/material-kit-react/views/componentsSections/javascriptStyles.jsx";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class SectionJavascript extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classicModal: false,
    };
  }
  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }
  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }
  handleClosePopover(state) {
    this.setState({
      [state]: false
    });
  }
  handleClickButton(state) {
    this.setState({
      [state]: true
    });
  }
  render() {
    const { classes } = this.props;
    return (
        <div>
            <ModalButton
                color="info"
                onClick={() => this.handleClickOpen("classicModal")}
                >
                <LibraryBooks className={classes.icon} />
            </ModalButton>
              <Dialog
                classes={{
                  root: classes.center,
                  paper: classes.modal
                  }}
              open={this.state.classicModal}
              TransitionComponent={Transition}
              keepMounted
              onClose={() => this.handleClose("classicModal")}
              aria-labelledby="classic-modal-slide-title"
              aria-describedby="classic-modal-slide-description"
              >
              <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              >
              <IconButton
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={() => this.handleClose("classicModal")}
              >
              <Close className={classes.modalClose} />
              </IconButton>
                <h4 className={classes.modalTitle}>JOCHGEM VAN DELFT, Coder and Designer</h4>
              </DialogTitle>
                <DialogContent
                id="classic-modal-slide-description"
                className={classes.modalBody}
                >
                <p>
                    I'm a React Developer and UI/UX Designer based in sunny Bali, Indonesia or Amersfoort, The Netherlands.
                </p>
                 <p>
                    I enjoy turning complex problems into simple, beautiful and intuitive designs using the latest React JS Libraries. 
                    When I'm not coding or designing, you'll find me travelling, photographing 
                    the world or enjoying great music.
                </p>
                <br/>
                <h5>Call or Whatsapp me on <strong>+31 655 456 933</strong></h5>
                </DialogContent>
                <DialogActions className={classes.modalFooter}>
                  <Button 
                    href="https://www.linkedin.com/in/jochgem-van-delft-28477b51/"
                    target="_blank"color="info" 
                    size="sm"
                    >
                    LinkedIn
                  </Button>
                  <Button
                    onClick={() => this.handleClose("classicModal")}
                    color="info"
                    simple
                    >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
        </div>
    );
  }
}

export default withStyles(javascriptStyles)(SectionJavascript);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionJavascript.jsx